import { Dispatch } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from 'js-cookie';

import { CatalogItemsCreateOrderInputApiI } from '../../api/def_client_api';
import { PaymentMethod, ReceivingMethod } from '../../api/def_common_api';
import { ApiErrorCode } from '../../api/errors';
import { Util } from '../../common/util/util';
import { BasketService } from '../../service/basket/basket.service';
import { BasketCatalogItemI } from '../../shared/types/basket';
import { basketActions } from '../../store/basket/basket.slice';
import { layoutActions } from '../../store/layout/layout.slice';
import { AppDispatch } from '../../store/store';

//Элемент в корзине LocalStorage
export interface BasketCatalogItemSimpleI {
  id: number;
  quantity: number;
}

//Информация о заказе
export interface BasketInfoI {
  order_quantity: number;
  order_sum: number;
}

//Возвращаемое значение создания заказа
export interface BasketCreateOrderRetI {
  //Ссылка на оплату
  pay_url: string;
  //Номер заказа
  main_order_id: number;
  //Номер ошибки
  error_code: ApiErrorCode;
  message: string;
}

//Корзина
export class Basket {
  /*
  Сохранить корзину в LocalStorage
  Сохраняет только идентификаторы и кол-во, т.к. цены и др. могут поменяться на сервере.
  Когда пользователь залогинится, то по идентификаторам получит полное описание товаров
  */
  public static saveToLocalStorage(basket_catalog_items: BasketCatalogItemI[]) {
    let basket_catalog_items_local_storage = basket_catalog_items.map(
      (r: BasketCatalogItemI) => {
        return {
          id: r.id,
          quantity: r.quantity,
        } as BasketCatalogItemSimpleI;
      }
      /*      (r: BasketCatalogItemI) => {
        return r;
      }*/
    );

    let json_basket = JSON.stringify(basket_catalog_items_local_storage);
    localStorage.setItem('basket', json_basket);
  }
  /*
  Сохранить корзину в LocalStorage по ID
  Сохраняет только идентификаторы и кол-во, т.к. цены и др. могут поменяться на сервере.
  Когда пользователь залогинится, то по идентификаторам получит полное описание товаров
  */
  /*public static saveToLocalStorageId(basket_catalog_items: BasketCatalogItemI[]) {
    let basket_catalog_items_local_storage = basket_catalog_items.map((id: BasketCatalogItemI) => {
      return id;
    });

    let json_basket = JSON.stringify(basket_catalog_items_local_storage);
    localStorage.setItem('basketId', json_basket);
  }*/
  // Получить корзину из LocalStorage по ID
  /*  public static getFromLocalStorageId(): BasketCatalogItemSimpleI[] {
    let basket_catalog_items_local_storage: BasketCatalogItemSimpleI[] = [];
    let json_basket = localStorage.getItem('basketId');
    if (json_basket != null && json_basket != '') {
      try {
        basket_catalog_items_local_storage = JSON.parse(json_basket);
      } catch (error) {
        //Ничего не делаем
      }
    }

    return basket_catalog_items_local_storage;
  }*/
  /*
  Получить корзину из LocalStorage
  Из LocalStorage только идентификаторы и кол-во, т.к. цены и др. могут поменяться на сервере.
  Когда пользователь залогинится, то по идентификаторам получит полное описание товаров
  */
  public static getFromLocalStorage(): any {
    let basket_catalog_items_local_storage: BasketCatalogItemSimpleI[] = [];
    let json_basket = localStorage.getItem('basket');
    if (json_basket != null && json_basket != '') {
      try {
        basket_catalog_items_local_storage = JSON.parse(json_basket);
      } catch (error) {
        //Ничего не делаем
      }
    }

    return basket_catalog_items_local_storage;
  }

  //Очистить корзину в LocalStorage и Redux
  public static emptyBasket() {
    localStorage.setItem('basket', '');

    let basket_catalog_items: BasketCatalogItemI[] = [];
    //Сохраняем в Redux
    let basket_info = Basket.getInfo(basket_catalog_items);
    return { basket_catalog_items, basket_info };
    /*   store.dispatch(action.setBasketCatalogItems(basket_catalog_items, basket_info.order_sum, basket_info.order_quantity));
     */
  }

  //Возвращает кол-во товаров в корзине и сумму заказа
  public static getInfo(
    basket_catalog_items: BasketCatalogItemI[]
  ): BasketInfoI {
    let basketInfo: BasketInfoI = {
      order_quantity: 0,
      order_sum: 0,
    };

    basket_catalog_items.forEach((item) => {
      basketInfo.order_quantity += item.quantity;
      basketInfo.order_sum += item.price_kopecks * item.quantity;
    });

    return basketInfo;
  }

  //Добавляет товар в корзину. Если уже есть такой товар, то не добавляется
  public static addItemToBasket(
    basket_catalog_items: BasketCatalogItemI[],
    item: BasketCatalogItemI
  ) {
    if (basket_catalog_items.findIndex((it) => item.id == it.id) == -1) {
      //Не нашли. Добавляем
      basket_catalog_items.push(item);
    }
  }

  //Устанавливаем кол-во товара в корзине
  public static setItemQuantityBasket(
    basket_catalog_items: BasketCatalogItemI[],
    id: number,
    quantity: number
  ) {
    let ind = basket_catalog_items.findIndex((it) => id == it.id);
    if (ind != -1) {
      basket_catalog_items[ind].quantity = quantity;
    }
  }

  //Удалить товар из корзины
  public static async deleteItemFromBasket(
    basket_catalog_items: BasketCatalogItemI[],
    id: number
  ) {
    const sessionToken = localStorage.getItem('st');
    let ind = basket_catalog_items.findIndex((it) => id == it.id);
    if (ind != -1) {
      basket_catalog_items.splice(ind, 1);

      //Удаляем с серверной корзины если залогинен
      if (sessionToken) {
        const dataResponce = await axios({
          method: 'delete',
          baseURL: process.env.REACT_APP_BASE_URL_API,
          url: '/api/admin/basket/synchronization/' + id.toString(),
          headers: {
            'session-token': sessionToken,
          },
        });
      }
    }
  }

  public static async addedOrRemoveCount(
    type: 'add' | 'remove',
    items: BasketCatalogItemI[],
    item: BasketCatalogItemI,
    basketIds: number[],
    dispatch: AppDispatch
  ) {
    const {
      setBasketCatalogItems,
      setOrderSum,
      setOrderQuantity,
      setAddCardsId,
    } = basketActions;
    //Копируем текущий массив
    let catalogItems = Util.clone(items);
    //Отнять из корзины
    let itemBasket = Basket.getItemFromBasket(catalogItems, item.id);
    let ind = basketIds.indexOf(item.id);
    let itemQuantity = itemBasket.quantity;

    if (type === 'add') {
      //Добавляем количество
      itemQuantity++;
      itemBasket.quantity = itemQuantity;
      let copy_checkedIds = [...basketIds];
      copy_checkedIds.push(itemBasket.id);
    }

    if (type === 'remove') {
      //Удаляем количество
      if (itemQuantity > 1) {
        itemQuantity--;
        itemBasket.quantity = itemQuantity;
      } else if (itemQuantity === 1) {
        //Удаляем
        await Basket.deleteItemFromBasket(catalogItems, itemBasket.id);
      }
    }

    let copy_checkedIds = [...basketIds];
    copy_checkedIds.splice(ind, 1);
    let basket_info = Basket.getInfo(catalogItems);
    //Сохраняем в LocalStorage
    Basket.saveToLocalStorage(catalogItems);
    //Сохраняем в Redux
    dispatch(setAddCardsId(copy_checkedIds));
    dispatch(setBasketCatalogItems(catalogItems));
    dispatch(setOrderSum(basket_info.order_sum));
    dispatch(setOrderQuantity(basket_info.order_quantity));
  }

  //Есть ли товар такой в корзине
  public static isItemExistBasket(
    basket_catalog_items: BasketCatalogItemI[],
    id: number
  ): boolean {
    let ind = basket_catalog_items.findIndex((it) => id == it.id);
    if (ind != -1) {
      return true;
    }

    return false;
  }

  //Получить товар из корзины
  public static getItemFromBasket(
    basket_catalog_items: BasketCatalogItemI[],
    id: number
  ) {
    let item: any = null;
    let ind = basket_catalog_items.findIndex((it) => id == it.id);
    if (ind != -1) {
      item = basket_catalog_items[ind];
    }

    return item;
  }

  public static FormABasket(
    basketItems: BasketCatalogItemSimpleI[],
    catalog_items: BasketCatalogItemI[]
  ) {
    //Формируем корзину
    let basketCatalogItems: BasketCatalogItemI[] = [];
    //Добавляем с сервера детальную информацию о товарах в корзине
    basketItems.forEach((el: BasketCatalogItemSimpleI) => {
      let ind = catalog_items.findIndex(
        (catalog_it: any) => el.id == catalog_it.id
      );
      let catalog_items_it = catalog_items[ind];
      if (ind != -1) {
        let catalog_item = {
          //тип BasketCatalogItemI
          id: el.id,
          quantity: el.quantity,
          slug: catalog_items_it.slug,
          title: catalog_items_it.title,
          img: catalog_items_it.img,
          availability: catalog_items_it.availability,
          availability_count: catalog_items_it.availability_count,
          price_kopecks: catalog_items_it.price_kopecks,
          unit: catalog_items_it.unit,
          updated_at: catalog_items_it.updated_at,
          stars_avg: catalog_items_it.stars_avg,
          reviews_comments_count: catalog_items_it.reviews_comments_count,
          vendor: {
            id: catalog_items_it.vendor.id,
            title: catalog_items_it.vendor.title,
            phone: catalog_items_it.vendor.phone,
            pavilion: catalog_items_it.vendor.pavilion,
          },
        };
        //Добавляем в корзину
        basketCatalogItems.push(catalog_item);
      }
    });

    return basketCatalogItems;
  }

  public static async addedBasketItems(
    basketItems: BasketCatalogItemSimpleI[],
    dispatch: AppDispatch
  ) {
    const { setBasketCatalogItems, setOrderQuantity, setOrderSum } =
      basketActions;
    let catalogItemsIds = basketItems.map(
      (r: BasketCatalogItemSimpleI) => r.id
    );
    //Детальная информация о товарах (без кол-ва)
    const { data: basketIds } = await BasketService.getDetailsItems(
      catalogItemsIds
    );

    if (!basketIds.error) {
      let catalogItems = basketIds.catalog_items;

      //Формируем новую корзину
      const basketCatalogItems = Basket.FormABasket(basketItems, catalogItems);

      //Сохраняем в Redux
      let basketInfo = Basket.getInfo(basketCatalogItems);
      dispatch(setBasketCatalogItems(basketCatalogItems));
      dispatch(setOrderSum(basketInfo.order_sum));
      dispatch(setOrderQuantity(basketInfo.order_quantity));
    }
  }

  //Загрузка локальной корзины
  public static async basketLoadLocal(dispatch: AppDispatch) {
    //Детальная информация о товарах (без кол-ва)
    let basketItems: BasketCatalogItemSimpleI[] = Basket.getFromLocalStorage();
    await Basket.addedBasketItems(basketItems, dispatch);
  }

  //Синхронизация серверной и локальной корзины
  public static async basketSynchronization(dispatch: AppDispatch) {
    let basketItems: BasketCatalogItemSimpleI[] = Basket.getFromLocalStorage();
    //Синхронизация
    const { data: synchronizationData } = await BasketService.synchronization(
      basketItems
    );
    if (!synchronizationData.error) {
      basketItems = synchronizationData.catalog_items_basket;
      await Basket.addedBasketItems(basketItems, dispatch);
    }
  }
  //Создать заказ
  //use_confirm_code - использовать ли код подтверждения по смс
  //Если use_confirm_code == false, то возвращает pay_url - содержит ссылку для оплаты
  //Возвращает pay_url и main_order_id
  public static async createOrder(
    catalog_items: any,
    order_sum_kopecks: number,
    checkout_phone: string,
    checkout_email: string,
    receiving_method: ReceivingMethod,
    payment_method: PaymentMethod,
    is_physical_person: boolean,
    delivery_sum_kopecks: number,
    delivery_address: string,
    delivery_date: Date | string,
    delivery_courier_comment: string,
    other_recipient: boolean,
    other_recipient_name: string,
    other_recipient_phone: string,
    session_token: string
  ): Promise<BasketCreateOrderRetI> {
    let retVal: BasketCreateOrderRetI = {
      pay_url: '',
      main_order_id: 0,
      error_code: ApiErrorCode.no_error,
      message: '',
    };

    let c_items: any = await catalog_items.map(
      (value: BasketCatalogItemI) =>
        ({
          id: value.id,
          vendor_id: value.vendor.id,
          quantity: value.quantity,
          title: value.title,
          price_kopecks: value.price_kopecks,
          unit: value.unit,
        } as any)
    );
    let catalogItemsCreateOrderInputApiI: CatalogItemsCreateOrderInputApiI = {
      catalog_items: c_items,
      order_sum_kopecks,
      delivery_sum_kopecks,
      delivery_address,
      delivery_date,
      delivery_courier_comment,
      other_recipient,
      other_recipient_name,
      other_recipient_phone,
      checkout_phone,
      checkout_email,
      receiving_method,
      payment_method,
      is_physical_person,
    };

    //Создать заказ
    const dataResponce = await axios({
      method: 'post',
      baseURL: process.env.REACT_APP_BASE_URL_API,
      url: '/api/admin/basket/create-order',
      headers: {
        'session-token': session_token,
      },
      data: catalogItemsCreateOrderInputApiI,
    });

    retVal.error_code = dataResponce.data.error_code;
    retVal.message = dataResponce.data.message;
    if (!dataResponce.data.error) {
      retVal.pay_url = dataResponce.data.pay_url;
      retVal.main_order_id = dataResponce.data.main_order_id;
    }
    return retVal;
  }

  public static async add_to_cart(
    item: BasketCatalogItemI,
    basketItems: BasketCatalogItemI[],
    dispatch: AppDispatch
  ) {
    if (item.availability === 'no' || item.availability_count < 1) return;
    const { setOpenSnackbar } = layoutActions;
    const { setBasketCatalogItems, setOrderQuantity, setOrderSum } =
      basketActions;
    //Копируем текущий массив
    let catalogItems: any = [...basketItems];
    let catalogItem = {
      //тип BasketCatalogItemI
      id: item.id,
      quantity: 1,
      slug: item.slug,
      title: item.title,
      img: item.img,
      availability: item.availability,
      availability_count: item.availability_count,
      price_kopecks: item.price_kopecks,
      unit: item.unit,
      updated_at: item.updated_at,
      stars_avg: item.stars_avg,
      reviews_comments_count: item.reviews_comments_count,
      vendor: {
        id: item.vendor.id,
        title: item.vendor.title,
        phone: item.vendor.phone,
        pavilion: item.vendor.pavilion,
      },
    };
    dispatch(setOpenSnackbar('Товар добавлен в корзину'));
    //Добавляем в корзину
    Basket.addItemToBasket(catalogItems, catalogItem);
    //Сохраняем в LocalStorage
    Basket.saveToLocalStorage(catalogItems);

    let basketInfo = Basket.getInfo(catalogItems);
    //Сохраняем в Redux
    dispatch(setBasketCatalogItems(catalogItems));
    dispatch(setOrderSum(basketInfo.order_sum));
    dispatch(setOrderQuantity(basketInfo.order_quantity));
  }
}
